export const ReadPlanBFFV1 = 'ReadPlanBFFV1'
export type ReadPlanBFFV1 = typeof ReadPlanBFFV1

export const ExperimentalReadPlanBFFV1 = 'ExperimentalReadPlanBFFV1'
export type ExperimentalReadPlanBFFV1 = typeof ExperimentalReadPlanBFFV1

export const ReadPlansBFFV1 = 'ReadPlansBFFV1'
export type ReadPlansBFFV1 = typeof ReadPlansBFFV1

export const ReadBlockBFFV1 = 'ReadBlockBFFV1'
export type ReadBlockBFFV1 = typeof ReadBlockBFFV1

export const ExperimentalReadBlockBFFV1 = 'ExperimentalReadBlockBFFV1'
export type ExperimentalReadBlockBFFV1 = typeof ExperimentalReadBlockBFFV1

export const ReadBlockConnectorCandidatesBFFV1 =
  'ReadBlockConnectorCandidatesBFFV1'
export type ReadBlockConnectorCandidatesBFFV1 =
  typeof ReadBlockConnectorCandidatesBFFV1

export const ReadMonthCalendarBFFV1 = 'ReadMonthCalendarBFFV1'
export type ReadMonthCalendarBFFV1 = typeof ReadMonthCalendarBFFV1

export const ReadBoardV3 = 'ReadBoardV3'
export type ReadBoardV3 = typeof ReadBoardV3

export const ReadBoardObjectsV3 = 'ReadBoardObjectsV3'
export type ReadBoardObjectsV3 = typeof ReadBoardObjectsV3

export const ReadWorkflowsV2 = 'ReadWorkflowsV2'
export type ReadWorkflowsV2 = typeof ReadWorkflowsV2

export const ReadWorkflowsV3 = 'ReadWorkflowsV3'
export type ReadWorkflowsV3 = typeof ReadWorkflowsV3
